import { useBroadcastEventHandler } from 'calling-integration-cross-tab/hooks/useBroadcastEventHandler';
import { useCallback } from 'react';
import { handleDialThirdParty } from '../utils/handleDialThirdParty';
import { openCallingWindow } from '../utils/callingWindowUtils';
import { getPersistedCallProvider } from 'calling-lifecycle-internal/utils/getLocalCallSettings';
import { useOwnerId } from '../hooks/useOwnerId';
import { useSelectedProviderContext } from 'calling-remote-common/context/SelectedProviderContext';
import { useOpenCloseRemote } from '../hooks/useOpenCloseRemote';
import { useOpenWidgetDataContext } from 'calling-integration-sdk-support/viewport/contexts/OpenWidgetDataContext';
import { useThirdPartyWidgetDetailsContext } from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { useUserInfo } from 'calling-ui-library/user-info/context/UserInfoContext';
import { sendCrossTabMessage } from 'worker-connection-library/calling-cross-tab-utils/sendCrossTabMessage';
import { createBroadcastMessage } from 'calling-integration-cross-tab/messages/createBroadcastMessages';
import { OPEN_WIDGET } from 'calling-integration-cross-tab/types/BroadcastEvents';
import { crossTabConnectionManager } from 'calling-integration-cross-tab/connectionManagement/CrossTabConnectionManager';
const sendDialNumberToCallingWindow = dialNumberDetails => {
  sendCrossTabMessage(createBroadcastMessage({
    type: OPEN_WIDGET,
    payload: {
      dialNumberDetails
    }
  }));
};
const UsesHostAppEvents = () => {
  const {
    userId
  } = useUserInfo();
  const {
    ownerId
  } = useOwnerId({
    userId
  });
  const [context] = useThirdPartyWidgetDetailsContext();
  const {
    selectedCallProviderData,
    isRemoteEnabled,
    openProviderMenu
  } = useSelectedProviderContext();
  const {
    updateOpenWidgetDataForRemote,
    updateOpenWidgetDataForCallingWindow
  } = useOpenWidgetDataContext();
  const {
    openRemote,
    setHasThirdPartyOpened
  } = useOpenCloseRemote();
  const handleInitiateOutboundCall = useCallback(message => {
    if (!ownerId) return;
    const persistedProvider = getPersistedCallProvider();
    const isProviderMismatch = (persistedProvider === null || persistedProvider === void 0 ? void 0 : persistedProvider.name) !== selectedCallProviderData.name;
    if (isProviderMismatch) {
      openProviderMenu();
      return;
    }
    openRemote();
    setHasThirdPartyOpened(true);
    const dialNumberProcessors = [];
    if (!selectedCallProviderData.usesCallingWindow && !crossTabConnectionManager.matchesLastUpdatedTab()) {
      return;
    }
    if (isRemoteEnabled) {
      dialNumberProcessors.push(updateOpenWidgetDataForRemote);
    }
    if (selectedCallProviderData.usesCallingWindow) {
      if (!context.thirdPartyIsPopupOpen) {
        openCallingWindow();
        dialNumberProcessors.push(updateOpenWidgetDataForCallingWindow);
      } else {
        dialNumberProcessors.push(sendDialNumberToCallingWindow);
      }
    }
    handleDialThirdParty({
      openWidgetEvent: message.payload,
      ownerId,
      dialNumberProcessors
    });
  }, [context.thirdPartyIsPopupOpen, isRemoteEnabled, openRemote, ownerId, selectedCallProviderData.name, selectedCallProviderData.usesCallingWindow, setHasThirdPartyOpened, updateOpenWidgetDataForRemote, updateOpenWidgetDataForCallingWindow, openProviderMenu]);
  useBroadcastEventHandler({
    onInitiateOutboundCall: handleInitiateOutboundCall
  });
  return null;
};
export default UsesHostAppEvents;